import i18n from 'i18n/config';
import { SECONDS_IN_DAY, SECONDS_IN_HOUR, SECONDS_IN_MINUTE } from 'utils/utils';

export const getExpirationTranslation = (expiration: number) => {
  const now = Date.now();
  const totalSeconds = Math.max(0, Math.floor((expiration - now) / 1000));

  if (totalSeconds <= 0) return i18n.t('workspaces.invite_expired');

  if (totalSeconds >= SECONDS_IN_DAY) {
    const days = Math.floor(totalSeconds / SECONDS_IN_DAY);
    return i18n.t('workspaces.invite_expires_in_days', { count: days });
  }

  if (totalSeconds >= SECONDS_IN_HOUR) {
    const hours = Math.floor(totalSeconds / SECONDS_IN_HOUR);
    return i18n.t('workspaces.invite_expires_in_hours', { count: hours });
  }

  const minutes = Math.floor(totalSeconds / SECONDS_IN_MINUTE);
  return i18n.t('workspaces.invite_expires_in_minutes', { count: minutes > 1 ? minutes : 1 });
};
